import React, { useContext } from 'react'

export const PageContext = React.createContext()

export const useLocale = () => useContext(PageContext).locale

export const useHrefLang = () => useContext(PageContext).hrefLang

export const usePageContext = () => useContext(PageContext)
